import { Box } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationScoreGeralAlunos } from '@/features/dashboard/api/getConsolidationScoreGeralAlunos.ts';
import ScoreGeralAlunosChart from './components/ScoreGeralAlunosChart.tsx';
import LoadingChart from '@/features/dashboard/components/LoadingChart.tsx';

const ScoreGeralAlunos = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationScoreGeralAlunos(yearProp);

  const listYears = Object
    .keys(groupBy(data, 'ano'))
    .map((item) => Number(item))
    .sort((a, b) => b - a);

  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched && listYears.length) {
      setYear(listYears[0]);
    }
  }, [isFetched, listYears]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear);
  };

  return (
    <>
      <LoadingChart loading={isFetching} />

      {
        data?.length && (
          <ScoreGeralAlunosChart
            title={'Histórico de Score geral dos alunos'}
            lineColor={'#1d5af5'}
            pointColor={'#09238e'}
            data={data}
          />
        )
      }

      {
        isFetched && (
          <Box marginTop={'10px'}>
            <PeriodFilter year={year} years={listYears} onApplyFilter={onApplyFilter} />
          </Box>
        )
      }
    </>
  );
};

export default ScoreGeralAlunos;
